import React, { useContext, useState, useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../../components/panel/panel.jsx';
import PageContext from '../../../config/page-settings.js';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { store } from 'react-notifications-component';
import * as API from '../../../services/api';

import CheckboxTree from 'react-checkbox-tree';
import { useMemo } from 'react';

const schemaCountryCreate = yup.object().shape({
  first_name: yup.string().required('First name is required'),
  last_name: yup.string().required('Last name is required'),
  username: yup.string().required('Username is required').min(8, 'Must be minimum 8 characters'),
  password: yup
    .string()
    .required('Password is required')
    .min(8, 'Password is too short - Must be minimum 8 characters'),
  email: yup.string().email('Invalid email format').required('Email is required'),
  mobile_number: yup
    .string()
    .required('Mobile number is required')
    .min(8, 'Mobile number is too short - Must be minimum 8 characters')
    .matches(/^\d+$/, 'Mobile number is invalid')
});

const CountryCreate = (props) => {
  const [checked, setChecked] = useState([]);
  const [expanded, setExpanded] = useState([]);

  const [nodes, setNodes] = useState([]);

  const pageContext = useContext(PageContext);

  useEffect(() => {
    pageContext.handleSetPageSidebar(true);
    pageContext.handleSetPageHeader(true);
    pageContext.handleSetPageContentFullWidth(false);

    API.getPermissions().then((res) => {
      const nodesList = res.data.permissions.map((parentPermission) => {
        return {
          value: parentPermission.id,
          label: parentPermission.name,
          children: parentPermission.permissions.map((childPermission) => ({
            value: childPermission.name,
            label: childPermission.name
          }))
        };
      });
      setNodes(nodesList);
    });
  }, []);

  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm({
    resolver: yupResolver(schemaCountryCreate)
  });

  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const onUserCreate = (data) => {
    const params = {
      ...data,
      is_otp_required: data.is_otp_required ? 1 : 0
    };

    setLoadingSubmit(true);
    API.userCreate(params)
      .then((res) => {
        store.addNotification({
          title: 'User Created',
          message: `User successfully created!`,
          type: 'success',
          insert: 'top',
          container: 'top-right',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut'],
          dismiss: {
            duration: 3000,
            onScreen: true
          }
        });

        props.history.push('/user/list');
        // props.onLogin(res.data.data);
      })
      .catch((err) => {
        console.log(err.response);
      })
      .finally(() => {
        setLoadingSubmit(false);
      });
  };

  const PermissionList = useMemo(() => {
    return (
      <CheckboxTree
        nodes={nodes}
        checked={checked}
        expanded={expanded}
        onCheck={(checked) => setChecked(checked)}
        onExpand={(expanded) => setExpanded(expanded)}
        icons={{
          check: <i className="fa fa-check-square" />,
          uncheck: <i className="fa fa-square" />,
          halfCheck: <i className="fa fa-check-square" />,
          expandClose: <i className="fa fa-chevron-right" />,
          expandOpen: <i className="fa fa-chevron-down" />,
          expandAll: <i className="fa fa-plus-square" />,
          collapseAll: <i className="fa fa-minus-square" />
          //   parentClose: <i className="fa fa-folder" />,
          //   parentOpen: <i className="fa fa-folder-open" />,
          //   leaf: <i className="fa fa-file" />
        }}
      />
    );
  }, [checked, expanded, nodes]);

  return (
    <div>
      {/* <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item">
          <Link to="/">Home</Link>
        </li>
        <li className="breadcrumb-item">
          <Link to="/user/list">User</Link>
        </li>
        <li className="breadcrumb-item active">
          <Link to="/user/create">User Create</Link>
        </li>
      </ol> */}
      <h1 className="page-header">Country Create</h1>

      <div className="row">
        <div className="col-xl-12">
          <Panel>
            <PanelHeader>Information</PanelHeader>
            <PanelBody>
              <div className="row">
                <div className="col-xl-6">
                  <form onSubmit={handleSubmit(onUserCreate)}>
                    <div className="row form-group m-b-10">
                      <label className="col-md-3 col-form-label">Country Name</label>
                      <div className="col-md-9">
                        <div className="input-group">
                          <input
                            {...register('name', { required: true })}
                            type="text"
                            className={`form-control form-control-md ${
                              errors.first_name ? 'is-invalid' : ''
                            }`}
                          />
                          {errors.first_name && (
                            <div className="invalid-feedback">{errors.first_name?.message}</div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row form-group m-b-10">
                      <label className="col-md-3 col-form-label">Country Sort</label>
                      <div className="col-md-9">
                        <div className="input-group">
                          <input
                            {...register('name', { required: true })}
                            type="text"
                            className={`form-control form-control-md ${
                              errors.first_name ? 'is-invalid' : ''
                            }`}
                          />
                          {errors.first_name && (
                            <div className="invalid-feedback">{errors.first_name?.message}</div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row form-group m-b-10">
                      <label className="col-md-3 col-form-label">Country Code</label>
                      <div className="col-md-9">
                        <div className="input-group">
                          <input
                            {...register('name', { required: true })}
                            type="text"
                            className={`form-control form-control-md ${
                              errors.first_name ? 'is-invalid' : ''
                            }`}
                          />
                          {errors.first_name && (
                            <div className="invalid-feedback">{errors.first_name?.message}</div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row form-group m-b-10">
                      <label className="col-md-3 col-form-label">Active</label>
                      <div className="col-md-9">
                        <div className="input-group">
                          <div className="switcher">
                            <input
                              {...register('is_otp_required', { required: false })}
                              type="checkbox"
                              checked="true"
                              name="is_otp_required"
                              id="is_otp_required"
                            />
                            <label htmlFor="is_otp_required"></label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row m-b-10">
                      <label className="col-md-3 col-form-label">&nbsp;</label>
                      <div className="col-md-9">
                        <button
                          type="submit"
                          className={`btn ${loadingSubmit ? 'btn-secondary' : 'btn-primary'}`}
                          disabled={loadingSubmit}
                        >
                          {loadingSubmit ? <i className="fas fa-spinner fa-spin"></i> : 'Submit'}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </PanelBody>
          </Panel>
        </div>
      </div>
    </div>
  );
};

export default withRouter(CountryCreate);
